import { useEffect, useState } from "react";
import "./StudentDetail.scss";
import StudentEditSection from "./StudentEditSection/StudentEditSection";
import { useLocation } from "react-router-dom";
import { fetchTrainingSessionById } from "../../../services/training-session.service";
import Headings from "../../../components/Headings/Headings";
import { AdminRoles } from "../../../utils/constants/app-constants";

const StudentDetail = ({trainingSession} : {trainingSession: any}) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sessionId = parseInt(queryParams.get("id") ?? "-1");
  const [trainingInstances, setTrainingInstances] = useState<any[]>([]);
  const [selectedInstanceId, setSelectedInstanceId] = useState(-1);
  const userRole = localStorage.getItem("role") ?? "";
  const [isPageLoading, setIsPageLoading] = useState(sessionId !== -1);
  const [totalStudents, setTotalStudents] = useState(0);

  const fetchSession = async () => {
    const result = await fetchTrainingSessionById(sessionId);
    const sessionData = result?.data?.trainingSession;
    const studentCountInstances = sessionData?.trainingInstance;

    if (sessionData) {
      setTrainingInstances(sessionData.trainingInstance);
      setSelectedInstanceId(sessionData.trainingInstance[0]?.id);
      setTotalStudents(studentCountInstances[0]?.totalStudent ?? 0);
    } 
  };

  const handleStudentDeleted = () => {
    setTrainingInstances(prev =>
      prev.map(instance => {
        if (instance.id === selectedInstanceId) {
          const updatedTotal = Math.max((instance.totalStudent ?? 0) - 1, 0);
          setTotalStudents(updatedTotal);
          return { ...instance, totalStudent: updatedTotal };
        }
        return instance;
      })
    );
  };
  
  const handleTabSwitch = (id: number) => {
    setSelectedInstanceId(id);
    const selectedInstance = trainingInstances.find(instance => instance.id === id);
    setTotalStudents(selectedInstance?.totalStudent ?? 0);
  };

  useEffect(() => {
    if (sessionId === -1) {
      return;
    }
    fetchSession();
  }, [sessionId]);

  useEffect(() => {
    if (selectedInstanceId === -1 || trainingInstances.length === 0) return;
  
    const selectedInstance = trainingInstances.find(
      (instance) => instance.id === selectedInstanceId
    );
  
    setTotalStudents(selectedInstance?.totalStudent ?? 0);
  }, [selectedInstanceId, trainingInstances]);
   
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsPageLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Headings
        className={`headings blue pb-1 mb-2 ${
          userRole === AdminRoles.MasterTrainer ? "pt-3" : ""
        }`}
        defaultClass="h7"
        size="h2"
        id="studentsDetails"
      >
        Student Details
      </Headings>
      <p className="h8 font-400" aria-label={`Number of students: ${totalStudents}`}> 
        <span id="student-count-label">Number of students: </span>  
        <span aria-labelledby="student-count-label">{totalStudents}</span>
      </p>
      {trainingInstances.length > 1 && (
        <div className="studentsClassTypes py-2">
          <ul>
            <li>
              <button
                className={
                  selectedInstanceId === trainingInstances[0].id ? "active" : ""
                }
                onClick={() => handleTabSwitch(trainingInstances[0].id)}
              >
                BEC
              </button>
            </li>
            <li>
              <button
                className={
                  selectedInstanceId === trainingInstances[1].id ? "active" : ""
                }
                onClick={() => handleTabSwitch(trainingInstances[1].id)}
                disabled={trainingInstances[0].status !== "COMPLETED"}
              >
                BEC TOT
              </button>
            </li>
          </ul>
        </div>
      )}
      {selectedInstanceId !== -1 && (
        <>
          {isPageLoading ? (
            <div className="aui-loader">
              <aui-loader type="content"></aui-loader>
            </div>
          ) : (
            <StudentEditSection
              instanceId={selectedInstanceId}
              trainingSession={trainingSession}
              onStudentsUploaded={() => fetchSession()}
              onStudentDeleted={() => handleStudentDeleted()}
            ></StudentEditSection>
          )}
        </>
      )}
    </>
  );
};

export default StudentDetail;
